module.exports = __webpack_public_path__ + "img/biogenColors.d2003896.png";